import { CardDetailsTileListSkeleton } from "@-/dev.improve.haniverse.routes.nav.app._components.card.tile.link.details.list";
import { DeckCardSectionGlyphTilesSkeleton } from "@-/dev.improve.haniverse.routes.nav.app.deck._components.deck-card-section.__views.glyph-tiles";
import { DeckCardSectionListSkeleton } from "@-/dev.improve.haniverse.routes.nav.app.deck._components.deck-card-section.__views.list";
import type { DeckDisplayMode } from "@-/dev.improve.haniverse.routes.nav.app.deck.entities";
import { Skeleton } from "@-/dev.improve.haniverse.components.ui.skeleton";
import { View } from "@-/com.npmjs.react-native";

/**
 * The accordion `fallback` for a {@link DeckCardListSection}: the skeleton of whichever view
 * `displayMode` selects, sized from the section's counts so the placeholder occupies the same
 * grid (or rows) the loaded section paints — never generic text lines above a card grid.
 */
export function DeckCardListSectionSkeleton({
  cardCount,
  characterCount,
  displayMode,
}: {
  /** Card tiles in the section (both tile grids render one tile per card). */
  cardCount: number;
  /** Characters in the section (the list renders one entry per character). */
  characterCount: number;
  displayMode: DeckDisplayMode;
}) {
  if (cardCount === 0) {
    // Mirrors the section's centered empty message.
    return (
      <View className="items-center px-4 py-6">
        <View className="h-5 justify-center">
          <Skeleton className="h-3.5 w-40" />
        </View>
      </View>
    );
  }

  if (displayMode === "morpheme-details-tiles") {
    return <CardDetailsTileListSkeleton padding={4} tileCount={cardCount} />;
  }

  if (displayMode === "morpheme-glyph-tiles") {
    return <DeckCardSectionGlyphTilesSkeleton tileCount={cardCount} />;
  }

  return <DeckCardSectionListSkeleton rowCount={characterCount} />;
}
